var _circle, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogOut({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    transform: "rotate(-180 20.5 20.5)",
    fill: "#0F8EB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0586 13.9657C14.0586 12.8924 14.0586 12.3563 14.0586 10.2097C14.0586 9.07304 15.0201 8.15159 16.2062 8.15159L25.8704 8.15159C27.0565 8.15159 28.018 9.07304 28.018 10.2097L28.018 30.7909C28.018 31.9275 27.0565 32.849 25.8704 32.849L16.2062 32.849C15.0201 32.849 14.0586 31.9275 14.0586 30.7909L14.0586 27.1746",
    fill: "#0F8EB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0586 13.9657C14.0586 12.8924 14.0586 12.3563 14.0586 10.2097C14.0586 9.07304 15.0201 8.15159 16.2062 8.15159L25.8704 8.15159C27.0565 8.15159 28.018 9.07304 28.018 10.2097L28.018 30.7909C28.018 31.9275 27.0565 32.849 25.8704 32.849L16.2062 32.849C15.0201 32.849 14.0586 31.9275 14.0586 30.7909L14.0586 27.1746",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1328 20.5001L20.5018 20.5001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9844 20.5L15.132 18.8893L15.132 22.1107L12.9844 20.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.ec130cc1e1b03daed6d82efdcb0bad87.svg";
export { ForwardRef as ReactComponent };